export const SERVICE = 'SEARCHES'

export const PAGE_LIMIT = 10
